<template>
  <div>
    <div class="font-bold mb-2">Block: {{ [block.name, block?.data?.layout].filter(str => str).join('-') }}</div>
    <ClientOnly> 
      <div class="debug text-xs" v-if="useRoute().query?.debug">{{ [block.name, block?.data?.layout].filter(str => str).join('-') }}</div>
      <!-- <div class="debug text-xs min-h-32">
        name: {{ block.name }}
        <br>
        layout: {{ block?.data?.layout ?? '-' }}
      </div> -->
    </ClientOnly>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})
</script>

<style lang="scss" scoped>
//
</style>